<template>
  <Content @back="back" :noBack="['expert','organ'].includes(userRole)" style="width:1024px">
    <template v-slot:nav_left>
      <div class="nav-btn-box">
        <div class="btn active" >教练员管理</div>
        <div class="btn" @click="jumpTo('/coach/majorDomoList')" >青训总监</div>
        <div class="btn" @click="jumpTo('/coach/technicalTeamList')" >复合团队</div>
      </div>
    </template>
    <template v-slot:nav_right>
      <template v-if="1 === activeNav && isCanEditData">
        <div
          class="yioks_btn"
          @click="
            addCoach = true;
            coachInfo = {};
            isEdit = false;
          "
        >
          <!-- <v-icon name="plus" scale="1"  style="margin-right: .1rem"></v-icon> -->
          添加教练员
        </div>
        <div class="yioks_btn" v-if="false" @click="batchAdd = true">批量导入教练员</div>
        <div class="yioks_btn" @click="download()">下载教练员信息</div>
      </template>
      <!-- <template v-if="(2 === activeNav) && (userRole === 'system')">
        <div class="yioks_btn" @click="addSupCoach = true;coachInfo={};isEdit=false">
          添加精英青训教练员
        </div>
        <div class="yioks_btn" @click="handleAddGroup">
          批量添加
        </div>
      </template> -->
    </template>
    <template v-slot:content_left="countNum">
      <p>{{ $t("allCoaches") }} : {{ countNum.countNum.coachNum }}</p>
    </template>
    <template v-slot:content_right>
      <div v-if="1 === activeNav" key="pannel-1">
        <div class="select_wrap">
          <div class="select_box">
            <select
              v-model="selectVal.organUuid"
              class="yioks_select"
              @change="changeSelectOrg"
            >
              <option v-if="selectOrganList.length > 1" value="">
                全部区体育行政部门
              </option>
              <option
                v-for="item in selectOrganList"
                :key="item.organUuid"
                :value="item.organUuid"
              >
                {{ item.organShortName }}
              </option>
            </select>
            <select
              v-model="selectVal.youthUuid"
              class="yioks_select"
              @change="changeQuery(true)"
            >
              <option v-if="selectCenterList.length !== 1" value="">
                全部培训机构
              </option>
              <option
                v-for="item in selectCenterList"
                :key="item.uuid"
                :value="item.uuid"
              >
                {{ item.youthShortName }}
              </option>
            </select>

            <select
              v-model="selectVal.classLevel"
              class="yioks_select"
              @change="changeQuery(true)"
            >
              <option value="">教练员等级</option>
              <option value="0">职业级</option>
              <option value="A">A级</option>
              <option value="B">B级</option>
              <option value="C">C级</option>
              <option value="D">D级</option>
              <option value="E">E级</option>
              <option value="other">其他</option>
            </select>
            <select
              v-model="selectVal.coachRankPhysicalType"
              class="yioks_select"
              @change="changeQuery(true)"
            >
              <option value="">体能等级</option>
              <option value="F1">体能L1</option>
              <option value="F2">体能L2</option>
            </select>
            <select
              v-model="selectVal.coachRankSpecialType"
              class="yioks_select"
              @change="changeQuery(true)"
            >
              <option value="">守门员等级</option>
              <option value="GC">守门员C级</option>
              <option value="GB">守门员B级</option>
              <option value="GA">守门员A级</option>
            </select>
            <select
              v-model="selectVal.coachNatureCoach"
              class="yioks_select"
              @change="changeQuery(true)"
            >
              <option value="">工作类型</option>
              <option value="全职">全职</option>
              <option value="兼职">兼职</option>
            </select>
            <select
              v-model="selectVal.coachLimit"
              class="yioks_select"
              @change="changeQuery(true)"
            >
              <option value="0">教练状态</option>
              <option value="1">未到期的教练</option>
              <option value="2">已到期的教练</option>
            </select>
            <select
              v-model="selectVal.isAuthComplete"
              class="yioks_select"
              @change="changeQuery(true)"
            >
              <option value="">注册情况</option>
              <option value="1">已注册</option>
              <option value="0">未注册</option>
            </select>
          </div>
          <div class="search_box">
            <input
              v-model.trim="selectVal.keyWord"
              type="text"
              class="yioks_input"
              placeholder="请输入关键词"
              @keyup.enter="changeQuery(true)"
            />
            <div class="yioks_btn yioks_input_button" @click="changeQuery(true)">搜索</div>
          </div>
        </div>
        <div class="list_wrap">
          <div v-if="showList" class="table">
            <div class="thead">
              <div class="tr">
                <div class="th seq"><strong>序号</strong></div>
                <div class="th idName"><strong>姓名</strong></div>
                <div class="th gender"><strong>性别</strong></div>
                <template v-if="userRole === 'system' || userRole === 'admin'|| userRole === 'expert'">
                  <div class="th unionName"><strong>所属单位</strong></div>
                </template>
                <template v-else>
                  <div class="th unionNameClub"><strong>所属球队</strong></div>
                </template>
                <template v-if="userRole === 'youth' || userRole === 'club'">
                  <div class="th exp"><strong>帐号有效期</strong></div>
                </template>
                <div class="th classLevel"><strong>教练等级</strong></div>
                <div class="th classLevel"><strong>体能等级</strong></div>
                <div class="th classLevel"><strong>守门员等级</strong></div>
                <div class="th coachNature"><strong>带队年限</strong></div>
                <div class="th coachNature"><strong>工作类型</strong></div>
                <div class="th auth"><strong>年度注册</strong></div>
                <div class="th opt"><strong>操作</strong></div>
              </div>
            </div>
            <div class="scrollArea">
              <vue-scroll>
                <div class="tbodyWrap">
                  <div class="tbody">
                    <div
                      v-for="(item, index) in coachList"
                      :key="index"
                      class="tr"
                    >
                      <div class="td seq">
                        <p>{{ index + 1 }}</p>
                      </div>
                      <div class="td idName">
                        <p  :class="{ coachLimit: item.coachLimitDate < new Date().setHours(0,0,0,0) }">
                          {{ item.idName }}
                        </p>
                      </div>
                      <div class="td gender">
                        <p>{{ item.gender }}</p>
                      </div>
                      <template v-if="userRole === 'system' || userRole === 'admin' || userRole === 'expert' ">
                        <template v-if="item.workName">
                          <div class="td unionName" :title="item.workName">
                            <p>{{ item.workName }}</p>
                          </div>
                        </template>
                        <template v-else>
                          <div class="td unionName">
                            <p>--</p>
                          </div>
                        </template>
                      </template>
                      <template v-else>
                        <template v-if="item.workSquadName">
                          <div class="td unionNameClub" :title="item.workSquadName">
                            <p>{{ item.workSquadName }}</p>
                          </div>
                        </template>
                        <template v-else>
                          <div class="td unionNameClub">
                            <p>--</p>
                          </div>
                        </template>
                      </template>
                      <template v-if="userRole === 'youth' || userRole === 'club'">
                        <div class="td exp"><p :class="{ coachLimit: item.coachLimitDate < new Date().setHours(0,0,0,0) }">{{item.coachLimitDate | time}}</p></div>
                      </template>
                      <div class="td classLevel" >
                        <div style="display:block;text-align:center">
                          <p>{{ item.classLevel | coachClassLevel}}</p>
                          <p v-if="item.coachLicenseEnd">{{ item.coachLicenseEnd}}</p>
                        </div>
                      </div>
                      <div class="td classLevel" >
                        <div style="display:block;text-align:center">
                          <p>{{ item.coachRankPhysicalType | coachClassLevel}}</p>
                          <p v-if="item.coachPhysicalLicenseEnd">{{ item.coachPhysicalLicenseEnd}}</p>
                        </div>
                      </div>
                      <div class="td classLevel" >
                        <div style="display:block;text-align:center">
                          <p>{{ item.coachRankSpecialType | coachClassLevel}}</p>
                          <p v-if="item.coachGoalieLicenseEnd">{{ item.coachGoalieLicenseEnd}}</p>
                        </div>
                      </div>
                      <div class="td coachNature" >
                        <p>{{ item.coachLeadYears ? item.coachLeadYears + '年' : '--'}}</p>
                      </div>
                      <div class="td coachNature" >
                        <p>{{ item.coachNatureCoach || '--'}}</p>
                      </div>
                      <div class="td auth">
                        <p :class="{ coachLimit: !item.isAuthComplete }">{{ item.isAuthComplete ? '已注册':'未注册'}}</p>
                      </div>
                      <div class="td opt">
                        <p>
                          <span class="item" @click="goInfo(item.uuid)">查看</span>
                          <span class="split" v-if="isCanEditData">/</span>
                          <span class="item" @click="editCoach(index)" v-if="isCanEditData">编辑</span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </vue-scroll>
            </div>
          </div>
          <yioks-loading v-if="loading" />
          <yioks-empty
            v-if="empty"
            tips="暂时没有数据 ~ "
            :name="isCanEditData ? '立即添加教练' : ''"
            @callback="
              addType = 'coach';
              addCoach = true;
              coachInfo = {};
              isEdit = false;
            "
          ></yioks-empty>
        </div>
        <Pagination :total="total" :page.sync="page" />
        <!-- 批量导入教练员 -->
        <el-dialog
          :visible.sync="batchAdd"
          width="500px"
          :title="$t('bulkImportCoaches')"
          :close-on-click-modal="false"
          custom-class="yioks_alert2"
        >
          <el-form
            ref="batchInfo"
            :model="batchInfo"
            :rules="formRules"
            label-width="110px"
          >
            <el-form-item label="管理单位" prop="organUuid">
              <el-select
                v-model.trim="batchInfo.organUuid"
                style="width: 100%"
                placeholder="请选择管理单位"
                @change="changeOrgInAddGroup"
              >
                <el-option
                  v-for="item in batchOrganList"
                  :key="item.organUuid"
                  :value="item.organUuid"
                  :label="item.organShortName"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="单位" prop="youthUuid">
              <el-select
                v-model.trim="batchInfo.youthUuid"
                style="width: 100%"
                placeholder="请选择管理单位后再选择单位"
                @change="changeBathCenter"
              >
                <el-option
                  v-for="item in batchCenterList"
                  :key="item.uuid"
                  :value="item.uuid"
                  :label="item.youthShortName"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="选择球队" prop="squadUuid">
              <el-select
                v-model.trim="batchInfo.squadUuid"
                style="width: 100%"
                placeholder="请选择单位后再选择球队"
                @change="changeSquad"
              >
                <el-option
                  v-for="item in squadList"
                  :key="item.uuid"
                  :value="item.uuid"
                  :label="item.shortName"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <UploadFile
            v-if="batchAdd"
            request="/api/zuxie/guozi/coach/Excel"
            :templateFile="tempUrl"
            templateFileName="批量导入教练员帐号模板文件.xlsx"
            @callBack="batchAddCoach"
          />
        </el-dialog>
        <template v-if="addCoach">
          <!-- 添加系统注册教练员 -->
          <AddCoachDialogList
            :coach="coachInfo"
            :addCoach.sync="addCoach"
            :organList="organList"
            :isEdit="isEdit"
            @hideDialog="hideDialog"
          ></AddCoachDialogList>
        </template>
        <yioks-tip
          :showTip="showPayCoach"
          tipMsg="新开通的教练员帐号试用期为三十天，请尽快点击右上角“教练员帐号开通”按钮进行支付费用后使用。"
          :confirmBtn="$t('iKnow')"
          @callback="payCoachConfirmCallback"
        />
      </div>

    </template>
  </Content>
</template>

<script>
import "vue-awesome/icons/regular/edit";
import coach from "@/api/coach";
import squad from "@/api/squad";
import person from "@/assets/images/common/person.jpg";
import { centerStatus } from "@/utils/yioks_filter";
// import formRules from '@/utils/formRules'
import rulesMixin from "@/utils/formRules/coach";
import { centerStatusList } from "@/utils/yioks_data";
import storage from "@/utils/storage";
import { ops } from "@/utils/scrollIndialog";
import { filterIdNumber,coachClassLevel } from "@/utils/yioks_filter";
import common from "@/api/common";
import pay from "@/api/pay";
import mixinAppConfig from "@/mixin/mixinAppConfig";
export default {
  components: {
    Content: () => import("@/components/layout/list"),
    Pagination: () => import("@/components/Pagination"),
    UploadFile: () => import("@/components/UploadFileSh"),
    // 'AddCoachDialog': () => import('@/components/coach'),  // 使用AddCoachDialog 替代
    AddCoachDialogList: () => import("@/components/coach/coachAdded"),
    AddSupCoachDialog: () => import("@/components/coach/SupIndex"),
    "stu-details": () => import("./StudentDetailsInfo"),
    "add-sup-group": () => import("./AddSupGroup"),
  },
  filters: {
    statusFilter(val) {
      return centerStatus(val);
    },
    filterIdNumber,
    coachClassLevel,
  },
  mixins: [rulesMixin,mixinAppConfig],
  data() {
    return {
      showPayCoach: false,
      downIng: false,
      ops,
      coachList: [],
      supCoachList: [],
      batchInfo: {
        organUuid: "",
        organShortName: "",
        youthShortName: "",
        youthUuid: "",
        squadUuid: "",
        squadName: "",
      },
      batchOrganList: [],
      batchCenterList: [],
      organList: [],
      selectOrganList: [],
      selectCenterList: [],
      squadList: [],
      centerList: [],
      userRole: storage.get("userInfo").userRole,
      uuid: storage.get("userInfo").uuid,
      total: 0,
      page: 0,
      pageSize: 20,
      empty: false,
      showList: false,
      person,
      addCoach: false,
      addSupCoach: false,
      addSupGroup: false, // 批量导入精英青训教练员
      selectVal: {
        keyWord: "",
        coachRankPhysicalType: "",
        coachNatureCoach: "",
        coachRankSpecialType: "",
        youthUuid: "",
        organUuid: "",
        className: "", // 培训班
        classLevel: "", // 教练员等级
        coachLimit: 0, // 教练员是否到期
        isAuthComplete: "", // 教练员是否注册
      },
      coachInfo: {
        phone: "",
        idName: "",
        idNumber: "",
        headImgUrl: "",
        userStatus: "EFFECTIVE",
        youthShortName: "",
        youthUuid: "",
        organShortName: "",
        confirmPassword: "",
        password: "",
        organUuid: "",
      },
      loading: true,
      addbtnLoading: false,
      batchAdd: false,
      isEdit: false,
      centerStatusList,
      // activeNav: 1, // 默认激活项目
      studentInfo: {}, // 查看精英教练员信息
      isShowStudentInfo: false,
      isShowDelete: false,
      deleteCoachUuid: false,
      classList: [], // 培训班列表
    };
  },
  computed: {
    activeNav() {
      const { activeNav } = this.$route.query;
      // if(+activeNav !== 1 && +activeNav !== 2){
      //   if(this.userRole === 'system' || this.userRole === 'admin') {
      //     return 2
      //   } else {
      //     return 1
      //   }
      // } else {
      //   return +activeNav
      // }
      if (activeNav && activeNav !== "undefined") {
        return Number(activeNav);
      } else {
        return 1;
      }
    },

    tempUrl() {
      const clubConfig = this.$store.getters.sysHostType;
      if (clubConfig === "club") {
        return "/uploads/templateFile/coachClub.xlsx";
      } else {
        return "/uploads/templateFile/coach.xlsx";
      }
    },
  },
  watch: {
    page() {
      this.changeQuery();
    },
    // 'batchInfo.organUuid': {
    //   handler (val) {
    //     this.$set(this.batchInfo, 'youthUuid', '')
    //     this.$set(this.batchInfo, 'youthShortName', '')
    //     if (val) {
    //       this.batchCenterList = this.batchOrganList.find(item => {
    //         return item.organUuid === this.batchInfo.organUuid
    //       }).youthList || []
    //       this.batchInfo.organShortName = this.batchOrganList.find(item => {
    //         return item.organUuid === this.batchInfo.organUuid
    //       }).organShortName
    //       if (this.batchCenterList.length === 1) {
    //         this.$set(this.batchInfo, 'youthUuid', this.batchCenterList[0].uuid)
    //         this.$set(this.batchInfo, 'youthShortName', this.batchCenterList[0].youthShortName)
    //       }
    //     } else {
    //       this.batchCenterList = []
    //     }
    //   }
    // },
    batchAdd(val) {
      if (!val) {
        // this.batchInfo = {
        //   organUuid: '',
        //   organShortName: '',
        //   youthShortName: '',
        //   youthUuid: ''
        // }
        // this.batchCenterList = []
        this.$refs["batchInfo"].resetFields();
      }
    },
  },
  created() {
    const { page, keyWord, coachRankSpecialType, coachRankPhysicalType, coachNatureCoach, organUuid, youthUuid, className,classLevel,coachLimit,isAuthComplete } =
      this.$route.query;
    page && (this.page = Number(page));
    keyWord && this.$set(this.selectVal, "keyWord", keyWord);
    coachRankSpecialType && this.$set(this.selectVal, "coachRankSpecialType", coachRankSpecialType);
    coachRankPhysicalType && this.$set(this.selectVal, "coachRankPhysicalType", coachRankPhysicalType);
    coachNatureCoach && this.$set(this.selectVal, "coachNatureCoach", coachNatureCoach);
    organUuid && this.$set(this.selectVal, "organUuid", organUuid);
    youthUuid && this.$set(this.selectVal, "youthUuid", youthUuid);
    className && this.$set(this.selectVal, "className", className);
    classLevel && this.$set(this.selectVal, "classLevel", classLevel);
    coachLimit && this.$set(this.selectVal, "coachLimit", coachLimit);
    isAuthComplete && this.$set(this.selectVal, "isAuthComplete", isAuthComplete);
    if (this.activeNav === 1) {
      this.getOrganListAndCenterList();
      this.getCoachAccount();
    } else {
      if (this.userRole === "system" || this.userRole === "admin" || this.userRole === "expert") {
        this.getSupCoachAccount();
      }
    }
    /* && this.userRole !== 'system' && this.userRole !== 'admin'*/
    if (!this.classList.length) {
      if (this.userRole == "system" || this.userRole == "admin" || this.userRole == "expert") {
        this.getCoachList();
      }
    }
  },
  methods: {
    back(){
      if ( this.userRole === "expert" || this.userRole === "organ"){
        this.$router.go(-1)
      }else if ( this.userRole === "admin"){
        this.$router.push('/home/index?details=mans')
      }else {
        this.$router.push('/home')
      }
    },
    // getOrganListAndCenterList (getlist) {
    getOrganListAndCenterList() {
      let data = this.uuid;
      let request = squad.getOrgListByYouth;
      if (this.userRole === "organ") {
        request = squad.getOrgListByOrgan;
        // data = this.uuid
      } else if (this.userRole === "system" || this.userRole === "admin" || this.userRole === "expert") {
        request = squad.getOrgListBySystem;
        data = "";
      } else if (
        this.userRole === "youth" ||
        this.userRole === "trainCamp" ||
        this.userRole === "club"
      ) {
        request = squad.getOrgListByYouth;
      }
      request(data).then((res) => {
        // this.organList = res
        this.selectOrganList = res;
        this.batchOrganList = res;
        if (this.selectOrganList.length === 1) {
          this.$set(
            this.selectVal,
            "organUuid",
            this.selectOrganList[0].organUuid
          );
          this.$set(
            this.batchInfo,
            "organUuid",
            this.batchOrganList[0].organUuid
          );
          this.$set(
            this.batchInfo,
            "organShortName",
            this.batchOrganList[0].organShortName
          );
          this.batchCenterList =
            this.batchOrganList.find((item) => {
              return item.organUuid === this.selectVal.organUuid;
            }).youthList || [];
          this.selectCenterList = this.batchCenterList;
          if (this.batchCenterList.length === 1) {
            this.$set(
              this.selectVal,
              "youthUuid",
              this.selectCenterList[0].uuid
            );
            this.$set(
              this.batchInfo,
              "youthUuid",
              this.batchCenterList[0].uuid
            );
            this.$set(
              this.batchInfo,
              "youthShortName",
              this.batchCenterList[0].youthShortName
            );
            this.squadList =
              this.selectCenterList.find((item) => {
                return item.uuid === this.batchInfo.youthUuid;
              }).squadList || [];
            if (this.squadList.length === 1) {
              this.batchInfo.squadUuid = this.squadList[0].uuid;
              this.batchInfo.squadShortName = this.squadList[0].shortName;
            }
          }
        }
        this.selectVal.organUuid && this.setCenterList();
        // getlist()
      });
    },

    // 管理单位切换
    changeSelectOrg() {
      this.$set(this.selectVal, "youthUuid", "");
      if (this.selectVal.organUuid) {
        this.selectCenterList =
          this.selectOrganList.find((item) => {
            return item.organUuid === this.selectVal.organUuid;
          }).youthList || [];
        if (this.selectCenterList.length === 1) {
          this.$set(this.selectVal, "youthUuid", this.selectCenterList[0].uuid);
        }
      } else {
        this.selectCenterList = [];
        this.$set(this.selectVal, "youthUuid", "");
      }
      this.changeQuery(true);
    },

    // 管理单位切换
    changeOrgInAddGroup(val) {
      this.$set(this.batchInfo, "youthUuid", "");
      this.$set(this.batchInfo, "youthShortName", "");
      if (val) {
        this.batchCenterList =
          this.batchOrganList.find((item) => {
            return item.organUuid === this.batchInfo.organUuid;
          }).youthList || [];
        this.batchInfo.organShortName = this.batchOrganList.find((item) => {
          return item.organUuid === this.batchInfo.organUuid;
        }).organShortName;
        if (this.batchCenterList.length === 1) {
          this.$set(this.batchInfo, "youthUuid", this.batchCenterList[0].uuid);
          this.$set(
            this.batchInfo,
            "youthShortName",
            this.batchCenterList[0].youthShortName
          );

          this.squadList =
            this.batchCenterList.find((item) => {
              return item.uuid === this.batchCenterList[0].uuid;
            }).squadList || [];
        }
      } else {
        this.batchCenterList = [];
      }
    },
    // 单位切换
    changeBathCenter(val) {
      this.batchInfo.youthShortName = this.batchCenterList.find((item) => {
        return item.uuid === this.batchInfo.youthUuid;
      }).youthShortName;

      this.squadList =
        this.batchCenterList.find((item) => {
          return item.uuid === val;
        }).squadList || [];
    },

    // 球队切换
    changeSquad(val) {
      this.batchInfo.squadName =
        this.squadList.find((item) => {
          return item.uuid === val;
        }).squadName || "";
    },
    getCoachAccount() {
      this.loading = true;
      this.empty = false;
      this.showList = false;
      let req = coach.getCoachAccountBySystem;
      if (
        this.userRole === "youth" ||
        this.userRole === "trainCamp" ||
        this.userRole === "club"
      ) {
        req = coach.getCoachAccountByYouth;
      } else if (this.userRole === "organ") {
        req = coach.getCoachAccountByOrg;
      }
      req({
        page: this.page,
        size: this.pageSize,
        key: this.selectVal.keyWord,
        coachNatureCoach: this.selectVal.coachNatureCoach,
        coachRankSpecialType: this.selectVal.coachRankSpecialType,
        coachRankPhysicalType: this.selectVal.coachRankPhysicalType,
        organUuid: this.selectVal.organUuid,
        youthUuid: this.selectVal.youthUuid,
        classLevel: this.selectVal.classLevel,
        coachLimit: this.selectVal.coachLimit,
        isAuthComplete: this.selectVal.isAuthComplete,
      })
        .then((res) => {
          this.loading = false;
          let data = res.content;
          this.total = res.totalElements;
          if (data.length) {
            this.coachList = data;
            this.showList = true;
          } else {
            this.empty = true;
          }
        })
        .catch((err) => {
          this.loading = false;
          console.error(err);
        });
    },

    // 获取精英青训教练员列表
    getSupCoachAccount() {
      this.loading = true;
      this.empty = false;
      this.showList = false;
      const { page, keyWord, coachRankSpecialType, coachRankPhysicalType, coachNatureCoach, className,classLevel,coachLimit,isAuthComplete } = this.$route.query;
      const queryParams = {
        page: page || this.page,
        size: this.pageSize,
        key: keyWord || "",
        className,
        classLevel,
        coachLimit,
        coachRankSpecialType,
        coachRankPhysicalType,
        coachNatureCoach,
        isAuthComplete,
      };
      coach
        .getCoachEliteListSystem(queryParams)
        .then((res) => {
          this.loading = false;
          this.total = res.totalElements;
          if (res.content.length) {
            this.supCoachList = res.content;
            this.showList = true;
          } else {
            this.empty = true;
          }
        })
        .catch((err) => {
          this.loading = false;
          console.error(err);
        });
    },

    editCoach(index) {
      this.coachInfo = { ...this.coachList[index] };
      if (!this.coachInfo.headImgUrl) this.coachInfo.headImgUrl = "";
      this.formRules.userUuid = this.coachInfo.uuid;
      this.addCoach = true;
      this.isEdit = true;
    },
    goInfo(uuid) {
      this.$router.push({
        path: "info",
        query: {
          uuid,
        },
      });
    },
    batchAddCoach(url,coachNum) {
      this.$refs["batchInfo"].validate((valid) => {
        if (valid) {
          let data = {
            coachToSquads: [this.batchInfo],
            path: url,
            coachNum: coachNum,
          };
          coach.batchAddCoach(data).then((res) => {
            this.batchAdd = false;
            if(res.code){
              this.$message.error(res.msg);
            }else{
              this.showPayCoach = true;
              this.$message.success("导入成功");
              this.getCoachAccount();
              this.getRenewYouthNum();
            }
          });
        }
      });
    },
    imgErr(index) {
      this.$set(this.coachList[index], "headImgUrl", this.person);
    },
    changeQuery(flag) {
      if (flag) this.page = 0;
      this.$router.replace({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          page: this.page,
          keyWord: this.selectVal.keyWord,
          coachRankPhysicalType: this.selectVal.coachRankPhysicalType,
          coachRankSpecialType: this.selectVal.coachRankSpecialType,
          coachNatureCoach: this.selectVal.coachNatureCoach,
          youthUuid: this.selectVal.youthUuid,
          organUuid: this.selectVal.organUuid,
          classLevel: this.selectVal.classLevel,
          coachLimit: this.selectVal.coachLimit,
          isAuthComplete: this.selectVal.isAuthComplete,
        },
      });
      // this.getCoachAccount()
      if (this.activeNav === 1) {
        this.getCoachAccount();
      } else {
        if (this.userRole === "system" || this.userRole === "admin" || this.userRole === "expert") {
          this.getSupCoachAccount();
        }
      }
    },

    setCenterList() {
      if (this.selectCenterList.length === 0) {
        this.selectCenterList =
          this.selectOrganList.find((item) => {
            return item.organUuid === this.selectVal.organUuid;
          }).youthList || [];
      }
      // this.centerList = this.batchCenterList = this.selectCenterList
    },
    hideDialog(val) {
      this.addCoach = val;
      if(!this.isEdit){
        this.showPayCoach = true;
      }
      this.getRenewYouthNum();
      this.getCoachAccount();
    },
    hideSupDialog(val) {
      this.addSupCoach = val;
      this.getSupCoachAccount();
    },

    // 导航切换
    navClick(activeIdx) {
      this.page = 0; // 切换后从第一页开始查询
      this.$set(this.selectVal, "keyWord", "");
      this.$router.replace({
        path: this.$route.path,
        query: {
          activeNav: activeIdx,
          page: 0,
        },
      });
      if (activeIdx === 1) {
        // this.getCoachAccount(this.getCoachAccount)
        if (!this.selectOrganList.length) this.getOrganListAndCenterList();
        this.getCoachAccount();
      } else {
        this.getSupCoachAccount();
      }
    },

    // 查看教练员详细信息
    toCheckSupInfo(row) {
      const { idNumber } = row;
      coach
        .getCoachInfoToTrain(idNumber)
        .then((res) => {
          if (res.code) {
            this.$message.error(res.msg);
            return;
          }
          if (res.objectBody.consequence === "ERROR") {
            this.$message.error(res.objectBody.msg);
            return;
          }
          const { objectBody, trainList } = res;
          // this.studentInfo = res.objectBody.result;
          this.studentInfo = Object.assign({}, objectBody.result, {
            trainList,
          });
          this.isShowStudentInfo = true;
        })
        .catch((err) => {
          console.error("err", err);
        });
    },

    // 删除提示
    deleteConfirmCallback(isSure) {
      if (isSure) {
        const uuid = this.deleteCoachUuid;
        coach
          .deletCoachElite(uuid)
          .then((res) => {
            this.isShowDelete = false;
            this.deleteCoachUuid = "";
            if (res.code) {
              this.$message.error(res.msg);
              return;
            }
            this.$message.success("删除成功!");
            this.changeQuery(true);
          })
          .catch((err) => {
            this.isShowDelete = false;
            console.error(err);
          });
      } else {
        this.isShowDelete = false;
      }
    },

    // 添加教练员提示
    payCoachConfirmCallback(isSure) {
      this.showPayCoach = false;
    },

    // 删除
    toDelete(row) {
      const { uuid } = row;
      this.deleteCoachUuid = uuid;
      this.isShowDelete = true;
    },

    // 批量添加精英青训教练员
    handleAddGroup() {
      this.addSupGroup = true;
    },

    // 处理批量添加回调
    handleAddSupGroup(flag, ok) {
      if (ok) {
        this.changeQuery(true);
      } else {
        // console.log('取消')
      }
      this.addSupGroup = flag;
    },

    // 获取培训班列表
    async getCoachList() {
      try {
        const res = await coach.coachClassList();
        if (res.code) {
          this.$message.error(res.msg);
          return;
        }
        this.classList = res.map((item) => {
          const { trainName, uuid } = item;
          return {
            label: trainName,
            content: trainName,
            key: uuid,
          };
        });
      } catch (err) {
        console.error("err", err);
      }
    },

    // 选择班级
    changeClass(val) {
      this.$router.replace({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          className: val,
        },
      });
      this.changeQuery(true);
    },
    jumpTo(path) {
      if(this.userRole === 'expert' || this.userRole === 'organ' ){
        this.$router.replace({
          path: path,
          query: {
            organUuid:this.selectVal.organUuid,
            youthUuid:this.selectVal.youthUuid,
          },
        });
      }else{
        this.$router.replace(path)
      }
    },
    goMajorDomo(){
      this.$router.push({
        path: "majorDomoList",
        query: {},
      });
    },
    goTeam(){
      this.$router.push({
        path: "technicalTeamList",
        query: {},
      });
    },
    download() {
      if (this.downIng) return;
      this.downIng = true;
      coach.getDownloadCoachAccountBySystem({
        key: this.selectVal.keyWord,
        coachRankPhysicalType: this.selectVal.coachRankPhysicalType,
        coachRankSpecialType: this.selectVal.coachRankSpecialType,
        coachNatureCoach: this.selectVal.coachNatureCoach,
        organUuid: this.selectVal.organUuid,
        youthUuid: this.selectVal.youthUuid,
        classLevel: this.selectVal.classLevel,
        coachLimit: this.selectVal.coachLimit,
        isAuthComplete: this.selectVal.isAuthComplete,
      }).then((res) => {
        const { fileName, filePath } = res;
        const transferPath = this.$yioksConfig.transferBaseOnly(filePath);
        common.downfile(transferPath, fileName);
        this.downIng = false;
      })
      .catch((err) => {
        this.downIng = false;
      });
    },
    // 获取俱乐部开通教练员数量
    getRenewYouthNum() {
      if(this.userRole === 'youth' || this.userRole === 'club'){
        pay.getRenewYouthNum().then((res) => {
          storage.set('renewYouthNum', Number(res)||0);
          this.$store.commit("setRenewYouthNum");
        });
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
.list_wrap
  flex 1
  overflow hidden
  height 470px
  .table
    display flex
    flex-direction column
    flex 1
    width 100%
    // margin: 30px 0 0;
    .thead, .tbody
      border 1px solid $color_white
    .thead
      margin 0 40px
      .tr
        height 45px
        display flex
    .scrollArea
      height 425px
      padding-bottom 15px
      /* flex 1 */
      /* overflow hidden */
    .tbodyWrap
      display block
      // padding: 0 40px;
    .tbody
      display block
      width 1024px
      margin-left auto
      margin-right auto
      max-width 944px
      border-top none
      border-bottom none
      .tr
        height 49px
        display flex
        border-bottom 1px solid $color_white
    .th, .td
      height 100%
      /* flex: 1 1 auto; */
      display flex
      justify-content center
      align-items center
      font-size $font_size_medium
      border-right 1px solid $color_white
    .th:last-child, .td:last-child
      border-right none
    .td
      p
        white-space nowrap
        overflow hidden
        text-overflow ellipsis
        color $color_white
    .exp
      width 10%
    .unionName
      width 18%
      box-sizing border-box
      p
        padding 0 4px
    .unionNameClub
      width 10%
      box-sizing border-box
      p
        padding 0 4px
    .seq
      width 4%
    .idName
      width 9%
      box-sizing border-box
    .classLevel
      width 10%
    .coachNature
      width 8%
    .auth
      width 7%
    .gender
      width 5%
    .phone
      width 14%
    .opt
      width 9%
      p
        width 100%
        text-align center
        .item
          cursor pointer
          user-select none
          color $green_color
        .split
          margin 0 5px
    .coachLimit
      color #f88594 !important
.demo-ruleForm
  height 475px
.tip
  margin-top 10px
  color red
  width 100%
  text-align center
  word-break break-word
.nav-btn-box
  display flex
  .btn
    margin-right 20px
    padding 10px 15px
    cursor pointer
    user-select none
    &.active
      background-color $green_color
.dialog-content
  height 550px
  .info-wrapper
    margin 0px 25px
.yioks_long_select
  width 365px !important
.yioks_select
  width 95px !important
.yioks_input
  width 80px !important
.yioks_input_button
  width 70px !important
.select_wrap
  padding 20px 40px 20px 20px

</style>
